<section class="cmn-innerpage-wrapper banking">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>
    <!-- <button class="cmn-upload-btn">
            <img src="assets/images/icons/icon-upload.svg" alt="Upload Icon" />
            <span>Import Statement</span>
        </button> -->
    <button class="cmn-add-btn" [routerLink]="'/banking/add-bank-account'" *ngIf="canCreateBanking$ | async">
      <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add
      Bank/Credit Card
    </button>
    <!-- Filter -->
    <div
      [ngClass]="{ show: isDropdownOpen }"
      class="common-dropdown filter-position"
      #dropdown
    >
      <button class="close-dropdown" (click)="toggleDropdown($event)"></button>
      <form>
        <h6 class="cmn-popup-heading">Filter <span>Clear All</span></h6>
        <div class="filter-inner-content">
          <h2>Branch</h2>
          <div class="check-wrapper">
            <div class="check-box">
              <label class="checkbox-wrapper">
                <input type="checkbox" />
                test
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="btn-wrapper">
          <button class="cmn-apply-btn" type="submit">Apply</button>
        </div>
      </form>
    </div>
    <!-- Filter -->
  </div>
  <div *ngIf="loading" class="loading-message">Loading...</div>
  <div *ngIf="canListBanking$ | async">
    <div *ngIf="!loading" class="inner-content">
      <p class="cmn-title">Bank Accounts</p>
      <div
        class="banking-table-wrapper"
        *ngIf="accounts?.length > 0; else noData"
      >
        <table>
          <thead>
            <tr>
              <th>Account Details</th>
              <th>Account Number</th>
              <th>Account Type</th>
              <th>Opening Balance</th>
              <th>Current Balance</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr (click)="openDetailPage(account?.id)"  class="account-detail-row" *ngFor="let account of accounts">
              <td class="title">
                <div>
                  <img
                    src="assets/images/icons/icon-bank-account.svg"
                    alt="Bank Account"
                  />{{ account?.bankName }}
                </div>
              </td>
              <td>{{ account?.accountNumber || "--" }}</td>
              <td>{{ account?.accountType || "--" }}</td>
              <td>
                {{ account?.openingBalance ? account?.currency : '' }} {{ account?.openingBalance.toFixed(2) || "--" }}
              </td>
              <td>
                {{ account?.currentBalance ? account?.currency : '' }} {{ account?.currentBalance || "--" }}
              </td>
              <!-- <td>{{ account?.expiryDate | date : "dd MMM yyyy"  }}</td> -->
              <td>
                <button (click)="onEditBankAccount(account?.id)" *ngIf="canEditBanking$ | async">
                  <img src="assets/images/icons/icon-edit.svg" alt="Edit Icon" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noData>
        <div class="no-data-message">No data found.</div>
      </ng-template>
    </div>
    <div *ngIf="!loading" class="inner-content">
      <p class="cmn-title">Credit Cards</p>
      <div
        class="banking-table-wrapper"
        *ngIf="creditCards?.length > 0; else noData"
      >
        <table>
          <thead>
            <tr>
              <th>Card Details</th>
              <th>Card Number</th>
              <th>Issuer</th>
              <th>Credit Limit</th>
              <th>Current Balance</th>
              <th>Expiry Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr class="account-detail-row" *ngFor="let credit of creditCards">
              <td class="title">
                <div>
                  <img
                    src="assets/images/icons/icon-bank-account.svg"
                    alt="Bank Account"
                  />{{ credit?.cardName }}
                </div>
              </td>
              <td>{{ credit?.cardNumberMasked | maskCardNumber }}</td>
              <td>{{ credit?.issuer || "--" }}</td>
              <td>{{  credit?.creditLimit ? credit?.currency : '' }} {{ credit?.creditLimit.toFixed(2) || "--" }}</td>
              <td>{{ credit?.currentBalance ? credit?.currency : '' }} {{ credit?.currentBalance.toFixed(2) || "--" }}</td>
              <td>{{ credit?.expiryDate | date : "dd MMM yyyy" }}</td>
              <td>
                <button (click)="onEditCreditCard(credit?.id)" *ngIf="canEditBanking$ | async">
                  <img src="assets/images/icons/icon-edit.svg" alt="Edit Icon" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noData>
        <div class="no-data-message">No data found.</div>
      </ng-template>
    </div>
  </div>
</section>
